import "./App.css";
import Routes from "./Routes";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import React, { Component } from "react";
import "react-tooltip/dist/react-tooltip.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
// import { io } from "socket.io-client";
// import { Authorization } from "./static.js";
const rtlTheme = createTheme({
  direction: "rtl",
  typography: { fontFamily: ["SFUIDisplayBold"], fontSize: 16 },
  palette: {
    primary: {
      main: "#d6783a",
    },
  },
});

export default class App extends Component {
  render() {
    return (
      <ThemeProvider theme={rtlTheme}>
        <div className="App">
          <Routes />
          <ToastContainer transition={Slide} />
        </div>
      </ThemeProvider>
    );
  }
}
